import { sendGTMEvent } from '@next/third-parties/google'
import useSWR from 'swr'

import { useNowGetZipCodeFromLocalStorage } from '../../now'
import { useCartIntermediateContext } from '../hooks/useCartIntermediateContext'

interface PdpData {
  price: number
  productId: string
}

/**
 * Hook that will resned initial PDP GTM data when the cart intermediate drawer is closed.
 * This is useful to ensure that the GTM data is up-to-date when the user navigates back
 * to the PDP after interacting with the cart intermediate drawer.
 */
export const useCartIntermediateDrawerResendInitialPdpGtmValue =
  (): (() => Promise<void>) => {
    const { pdpGtmData } = useCartIntermediateContext()
    const gtmDataToPush = pdpGtmData?.gtmDataToPush
    const gtmApiUrl = pdpGtmData?.gtmApiUrl
    const zipCode = useNowGetZipCodeFromLocalStorage()

    const zipCodeUrl = `${gtmApiUrl}&zipCode=${zipCode}`
    const apiUrlMutation = useSWR<PdpData>(zipCodeUrl)

    return async () => {
      const pdpData = await apiUrlMutation.mutate()
      if (!gtmDataToPush) {
        return
      }

      for (const data of gtmDataToPush) {
        sendGTMEvent({ ...data, ...pdpData })
      }
    }
  }
